import styled from "styled-components";
import { useApp } from "../../contexts";
import Modal from "../Modal/Modal";
import { Divider } from "antd";
import { useState } from "react";

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .description p {
    margin-bottom: 16px;
  }
`;

export default function ModalVerifyPhoneCommon({
  onClose,
  onSubmit,
  ...props
}) {
  const { T } = useApp();

  const renderUpdateIcon = () => {
    return (
      <svg
        width="58"
        height="59"
        viewBox="0 0 58 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M42.7462 25.9103C39.8489 25.9103 38.3952 29.4205 40.4438 31.4691C40.8211 31.8464 40.8211 32.4585 40.4438 32.8359L38.363 34.9165C37.9857 35.294 37.3736 35.294 36.9962 34.9165C34.9476 32.868 31.4375 34.3217 31.4375 37.219C31.4375 37.7529 31.0047 38.1854 30.4711 38.1854H27.5287C26.995 38.1854 26.5623 37.7529 26.5623 37.219C26.5623 34.3181 23.0548 32.8654 21.0036 34.9165C20.6262 35.294 20.0141 35.294 19.6367 34.9165L17.556 32.8359C17.1786 32.4585 17.1786 31.8464 17.556 31.4691C19.6046 29.4205 18.1509 25.9103 15.2535 25.9103C14.7197 25.9103 14.2871 25.4776 14.2871 24.9439V22.0016C14.2871 21.4679 14.7197 21.0352 15.2535 21.0352C18.1509 21.0352 19.6046 17.525 17.556 15.4765C17.1786 15.0991 17.1786 14.4871 17.556 14.1096L19.6367 12.0289C20.0141 11.6515 20.6261 11.6515 21.0036 12.0289C23.0522 14.0774 26.5623 12.6238 26.5623 9.72642C26.5623 9.19241 26.9951 8.75991 27.5287 8.75991H30.4711C31.0047 8.75991 31.4375 9.19241 31.4375 9.72642C31.4375 12.6238 34.9476 14.0774 36.9962 12.0289C37.3736 11.6515 37.9857 11.6515 38.363 12.0289L40.4438 14.1096C40.8211 14.487 40.8211 15.0991 40.4438 15.4765C38.3952 17.525 39.8489 21.0352 42.7462 21.0352C43.2802 21.0352 43.7126 21.4679 43.7126 22.0016V24.9439C43.7127 25.4775 43.2802 25.9103 42.7462 25.9103ZM41.0078 53.0144H4.19141V54.7845H41.0078V53.0144ZM2.60547 56.3704V51.4284H55.3945V56.3704H2.60547ZM56.1875 57.9564H1.8125C1.37455 57.9564 1.01953 57.6013 1.01953 57.1634V50.6356C1.01953 50.1976 1.37455 49.8426 1.8125 49.8426H56.1875C56.6254 49.8426 56.9805 50.1976 56.9805 50.6356V57.1634C56.9805 57.6013 56.6254 57.9564 56.1875 57.9564ZM19.7462 38.5447L15.9327 38.6967C15.6953 38.6898 15.4575 38.7891 15.2955 38.987C15.1172 39.2049 15.0743 39.4894 15.1566 39.7383L16.0427 43.436C16.1436 43.8602 16.5693 44.1223 16.9937 44.0214C17.418 43.9205 17.68 43.4948 17.5791 43.0704L17.1809 41.4089C21.0659 43.9744 25.6012 45.1452 30.08 44.9206C41.0961 44.3683 49.8956 35.5688 50.448 24.5527C50.7077 19.3729 49.1014 14.1172 45.6293 9.87958C45.3523 9.54087 44.8529 9.49091 44.5142 9.768C44.1755 10.0451 44.1255 10.5444 44.4027 10.8831C47.6204 14.81 49.1089 19.6797 48.8683 24.4782C48.3574 34.6685 40.1959 42.8299 30.0057 43.3408C25.9161 43.5459 21.7751 42.4947 18.2098 40.188L19.8081 40.1242C20.2444 40.1071 20.5841 39.7396 20.567 39.3034C20.55 38.8673 20.1824 38.5276 19.7462 38.5447ZM38.2537 8.40069L42.0672 8.24867C42.3045 8.25569 42.5424 8.15634 42.7044 7.95844C42.8827 7.74049 42.9257 7.45604 42.8433 7.20716L41.9571 3.50943C41.8562 3.0852 41.4305 2.82306 41.0061 2.924C40.5819 3.02493 40.3197 3.45064 40.4207 3.87499L40.8189 5.53637C36.9339 2.97089 32.3986 1.80013 27.9198 2.02466C16.9037 2.57702 8.10414 11.3765 7.55178 22.3926C7.29203 27.5724 8.89836 32.8281 12.3704 37.0657C12.6475 37.4044 13.1469 37.4544 13.4856 37.1772C13.8243 36.9001 13.8742 36.4008 13.5971 36.062C10.3795 32.1352 8.89099 27.2655 9.1316 22.4669C9.6425 12.2767 17.804 4.11526 27.9942 3.60436C32.0837 3.39921 36.2247 4.45046 39.79 6.75721L38.1918 6.82087C37.7555 6.83798 37.4158 7.20546 37.4329 7.64171C37.45 8.07807 37.8176 8.4178 38.2537 8.40069ZM29 16.4033C25.0958 16.4033 21.9307 19.5684 21.9307 23.4726C21.9307 27.3769 25.0958 30.542 29 30.542C32.9042 30.542 36.0693 27.3769 36.0693 23.4726C36.0693 19.5684 32.9042 16.4033 29 16.4033Z"
          fill="black"
        />
      </svg>
    );
  };

  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2
        width="1050px"
        className={"modal-mint"}
        onClose={onClose}
      >
        <ContentWaper>
          <div className="text-black text-center font-bold text-[18px]/[26px] lg:text-[24px]/[36px] lg:h-full">
            {T("update_infomation_title")}
          </div>
          <Divider className="my-6 border-t-2" />
          <div className="mt-[10px] lg:mt-[10px]">
            <div>
              <div className="flex justify-center items-center mb-6">
                {renderUpdateIcon()}
              </div>
              <div className="text-black font-bold text-center text-[16px]/[24px] lg:text-[24px]/[36px] mb-5 lg:text-[24px]">
                {T("update_infomation_sub_title")}
              </div>
              <div
                className="description mt-[20px] text-[16px]/[24px] lg:text-[24px]/[36px]  justify-center text-center items-center text-black"
                dangerouslySetInnerHTML={{
                  __html: T("update_infomation_des"),
                }}
              ></div>
              <div className="mt-[30px] mb-[20px] md:mb-[10px] flex flex-wrap flex-col-reverse md:flex-row md:flex-nowrap justify-center items-center gap-[20px]">
                <button
                  type="button"
                  className="w-full lg:w-[490px] bg-black leading-[56px] !text-white rounded-[56px] lg:rounded-[10px] px-[20px] h-[56px] text-[16px] lg:text-[24px]"
                  onClick={() => onSubmit?.()}
                >
                  {T("Update information now")}
                </button>
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
}
